import React from 'react'
import { DocumentTitle } from '../../components/DocumentTitle/DocumentTitle';
import CMLInfoPanel from './CMLInfoPanel';
import { Button, Tabs, Tooltip } from '@sede-enterprise/shell-ds-react-framework';
import CMLDetailsChart from './CMLDetailsChart';
import RelatedCMLData from './RelatedCMLData';
import { ChevronRight } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { DEFAULT_METRIC_SPEC } from '../../util/constants';
import { useMetricChartHook } from '../../components/MetricChart/useMetricChartHook';


const CMLDetailsScreen = ({
    units,
    prodUnit,
    cmlID,
    equipmentId,
    cmlShortName,
    cmlCorrosionLoop,
    cmlSite,
    cmlData,
}) => {

    const {
        data,
        metricData,
        loading,
        start,
        setStart,
        end,
        setEnd,
        interval,
        setSelectedInterval,
        intervalOpts,
        setRequestParams,
        formDirty,
        refreshChartData,
        refreshScatterData,
        scaled,
        setScaled,
    } = useMetricChartHook(DEFAULT_METRIC_SPEC);


    return (
        <>
            <DocumentTitle title={`CARMA - CML ${cmlID}`} />
            <div className='parent-container'>
                <div className='content-container'>
                    <div className='details-title'>
                        <h4>Equipment: {equipmentId?.length > 13 ? <Tooltip className='remanent-tooltip' placement='bottom'
                            overlay={<div className='tooltip-content'>{equipmentId}</div>}
                            trigger={<Button style={{ padding: "0px" }} variant='transparent' onClick={() => { }}>{equipmentId?.substring(0, 13)}...</Button>} /> : equipmentId}</h4>
                        <ChevronRight />

                        <h4>CL:  <Link
                            className="link"
                            to={`/cls/${encodeURIComponent(cmlCorrosionLoop)}/details`}

                        >
                            {cmlCorrosionLoop}
                        </Link></h4>
                        <ChevronRight />

                        <h4>CML:  {cmlShortName}</h4>
                    </div>
                    <Tabs tabBarStyle={{
                        justifyContent: 'flex-start',
                        borderBottom: '1px solid #E0E0E0',
                        marginBottom: '20px'
                    }}
                        defaultActiveKey='features'
                        items={[
                            {
                                label: 'Details',
                                key: 'details',
                                children: <CMLInfoPanel units={units} cmlID={cmlID} site={cmlSite} prodUnit={prodUnit} />
                            },
                            {
                                label: 'Features',
                                key: 'features',
                                children: <CMLDetailsChart
                                    units={units}
                                    prodUnit={prodUnit}
                                    cmlID={cmlID}
                                    site={cmlSite}
                                    data={data}
                                    metricData={metricData}
                                    cmlData={cmlData}
                                    loading={loading}
                                    start={start}
                                    setStart={setStart}
                                    end={end}
                                    setEnd={setEnd}
                                    interval={interval}
                                    setSelectedInterval={setSelectedInterval}
                                    intervalOpts={intervalOpts}
                                    setRequestParams={setRequestParams}
                                    formDirty={formDirty}
                                    refreshChartData={refreshChartData}
                                    refreshScatterData={refreshScatterData}
                                    scaled={scaled}
                                    setScaled={setScaled}
                                />
                            },
                            {
                                label: 'Related CML Data',
                                key: 'related',
                                children: <RelatedCMLData
                                    units={units}
                                    cmlID={cmlID}
                                    cmlShortName={cmlShortName}
                                    cmlCorrosionLoop={cmlCorrosionLoop}
                                />
                            }

                        ]}
                    />
                </div>
            </div>
        </>
    )
}

export default CMLDetailsScreen